import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { useAuth } from "./useAuth";
import { supabaseClient } from "../utils/supabase";

export function useLogoutMutation() {
    const navigate = useNavigate();
    const { signOut } = useAuth();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async () => {
            // Sign out from Supabase
            await supabaseClient.auth.signOut();
        },
        onSuccess: () => {
            // Clear local auth state
            signOut();
            // Navigate to home page
            navigate({ to: "/logged-out" });
        },
        onError: (error) => {
            console.error("Logout error:", error);
            // Even if Supabase logout fails, clear local state
            signOut();
        },
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: ["user"] });
            queryClient.invalidateQueries({ queryKey: ["profile"] });
        },
    });
}
